module.exports = __webpack_public_path__ + "static/media/knex_logo.34714b8e.png";